import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { to: '/category/illustration', label: '萝莉插画' },
        { to: '/category/character', label: '角色设定' },
        { to: '/category/fanart', label: '同人创作' },
        { to: '/category/anime', label: 'ACG动漫' },
      ],
    },
    {
      title: '关于社区',
      links: [
        { to: '/about', label: '品牌介绍' },
        { to: '/about#contact', label: '联系我们' },
        { to: '/about', label: '加入我们' },
      ],
    },
    {
      title: '友情链接',
      links: [
        { to: '#', label: 'ACG同好会' },
        { to: '#', label: '插画师联盟' },
        { to: '#', label: '二次元导航' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-primary-500 text-2xl"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">
                萝莉次元
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注于二次元萝莉文化的创作与分享平台，汇聚ACG动漫插画、角色设定、同人创作等内容。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 萝莉次元 LoliDimension. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="B站">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bilibili-line"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="QQ">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-qq-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}